import React from 'lib/react';
import {
  EVGrid,
  makeStyles,
  EVCircularProgress,
  EVBox,
  EVBackdrop,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import Typography from 'commonComponents/typography';

const useStyles = makeStyles((theme) => ({
  overlay: {
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.75)',
  },
  placingOrderContainer: {
    display: 'flex',
    padding: '50px',
    gap: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  placingOrderHeading: {
    fontSize: '36px',
    fontWeight: 300,
    lineHeight: '54px',
  },
  circularProgressD: {
    left: 0,
    color: theme.evPalette.charcoal[300],
  },
  circularProgress: {
    position: 'absolute',
    left: 0,
    color: theme.evPalette.ocean[700],
  },
}));

function PlacingOrderLoader() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <EVBackdrop open className={classes.overlay}>
      <EVGrid className={classes.placingOrderContainer}>
        <EVBox sx={{ position: 'relative', paddingTop: '15px' }}>
          <EVCircularProgress
            variant="determinate"
            thickness={5.5}
            className={classes.circularProgressD}
            disableShrink
            value={100}
            size={48}
          />
          <EVCircularProgress
            variant="indeterminate"
            thickness={5.5}
            className={classes.circularProgress}
            size={48}
          />
        </EVBox>
        <EVGrid style={{ gap: '8px' }}>
          <Typography fontColor="ocean-700" className={classes.placingOrderHeading}>{t('finalize_order_placing_order')}</Typography>
          <Typography
            variant="subtitle-400"
            fontColor="charcoal-900"
          >
            {t('finalize_order_placing_order_description')}
          </Typography>
        </EVGrid>
      </EVGrid>
    </EVBackdrop>
  );
}

export default PlacingOrderLoader;
